var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.319 4.28894H22.9077V0H10.1276V4.28894H0.716309V11.0609H32.319V4.28894ZM13.5136 3.386H19.5217V4.28894H13.5136V3.386Z",
    fill: "#353C48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3117 24.1884L29.9505 14.4469H3.08447L5.23075 47.1783H18.117C16.4397 44.8005 15.4531 41.9022 15.4531 38.7776C15.4531 30.974 21.6037 24.58 29.3117 24.1884Z",
    fill: "#353C48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0617 27.5554C23.8737 27.5554 18.8394 32.5897 18.8394 38.7777C18.8394 44.9656 23.8737 50 30.0617 50C36.2497 50 41.2841 44.9657 41.2841 38.7777C41.2841 32.5896 36.2497 27.5554 30.0617 27.5554ZM36.1764 42.4981L33.7821 44.8923L30.0617 41.1719L26.3413 44.8923L23.947 42.4981L27.6675 38.7777L23.947 35.0572L26.3413 32.663L30.0617 36.3834L33.7821 32.663L36.1764 35.0572L32.4559 38.7777L36.1764 42.4981Z",
    fill: "#353C48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.9b56cbe23e6a7b9ccfd560ac5caad6ad.svg";
export { ForwardRef as ReactComponent };